import axios from 'axios';
import { ResponsiveEmbed } from 'react-bootstrap';
import { call, put, select } from 'redux-saga/effects';
import { API } from '../constants/api';
import { methods } from '../constants/constants';
import { actions } from '../reducers/usuarios';
import { sagaNames, handleSagaError } from './index';

export const usuariosFromStore = state => state.usuarios.usuarios;
export const rolesFromStore = state => state.usuarios.roles;

function buildTemporaryUsuarioEmail() {
  return `tmp_${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}@u.invalid`;
}

function fetchRoles() {
    //debugger;
    return axios({
        method: methods.GET,
        url: API.USUARIOS.GET_LIST_ROLES,
    });
}

function enrichUsuarioResponse(response, usuario) {
  return {
    ...response,
    data: {
      ...(response?.data || {}),
      nombreAcademiaPublica: response?.data?.nombreAcademiaPublica || usuario?.nombreAcademiaPublica || '',
      nombreAcademiaPrivada: response?.data?.nombreAcademiaPrivada || usuario?.nombreAcademiaPrivada || '',
      contrasena: '',
    },
  };
}

function fetchUsuarios() {
	return axios({
		method: methods.GET,
		url: API.USUARIOS.GET_LIST_USUARIOS,
	});
}

function postUsuariosData(usuario) {
	const normalizedEmail = typeof usuario.email === 'string' ? usuario.email.trim() : '';

	return axios({
		method: methods.POST,
		url: API.USUARIOS.GET_LIST_USUARIOS,
    data: {
        user: usuario.user,
        email: normalizedEmail || buildTemporaryUsuarioEmail(),
        rol : usuario.rol,
        id_academia : usuario.id_academia,
        id_academia_priv : usuario.id_academia_priv,
        contrasena : usuario.contrasena,
        usuarioExterno: !!usuario.usuarioExterno,
        desactivado: !!usuario.desactivado,
        fecha_desactivacion: usuario.fecha_desactivacion || null,
    },
	});
}

function putUsuariosData(usuario) {
	return axios({
		method: methods.PUT,
		url: API.USUARIOS.GET_LIST_USUARIOS,
    data: {
        id: usuario.id,
        user: usuario.user,
        email : usuario.email,
        rol : usuario.rol,
        id_academia : usuario.id_academia,
        id_academia_priv : usuario.id_academia_priv,
        contrasena : usuario.contrasena,
        desactivado: !!usuario.desactivado,
        fecha_desactivacion: usuario.fecha_desactivacion || null,
    },
	});
}

function deleteUsuariosData(usuario) {
	return axios({
		method: methods.DELETE,
        url: API.USUARIOS.GET_LIST_USUARIOS,
        data: {
            id: usuario.id,
            user: usuario.user,
            email : usuario.email,
            rol : usuario.rol,
            id_academia : usuario.id_academia,
            id_academia_priv : usuario.id_academia_priv,
            contrasena : usuario.contrasena,
        }
	});
}

function deleteUsuariosBatchData(usuarioIds) {
  return axios({
    method: methods.DELETE,
        url: API.USUARIOS.DELETE_BATCH_USUARIOS,
        data: usuarioIds,
  });
}

export function* getRoles() {
    //debugger;
    try {
        const rolesStore = yield select(rolesFromStore);
        let roles = null;
        if (!rolesStore || (Array.isArray(rolesStore) && rolesStore.length === 0)) {
            const response = yield call(fetchRoles);
            roles = response && response.data;
        } else {
            roles = rolesStore;
        }
        yield put(actions.successGetRoles(roles));
    } catch (error) {
        const reducerFailureAction = actions.errorGetRoles(error);
        yield handleSagaError(sagaNames.GET_ROLES, error, reducerFailureAction);
    }
}

export function* getUsuarios(args = {}) {
    try {
    const forceRefresh = Boolean(args.forceRefresh);
    const usuariosStore = yield select(usuariosFromStore);
    let usuarios = null;
    if (forceRefresh || !usuariosStore || (Array.isArray(usuariosStore) && usuariosStore.length === 0)) {
        const response = yield call(fetchUsuarios);
        //debugger;
        /* REGULAR BEHAVIOUR ENDS */
        // usuarios = normalizeusuarios(response);
        usuarios = response && response.data;
    } else {
        usuarios = usuariosStore;
    }
    yield put(actions.successGetUsuarios(usuarios));
  } catch (error) {
    const reducerFailureAction = actions.errorGetUsuarios(error);
    yield handleSagaError(sagaNames.GET_USUARIOS, error, reducerFailureAction);
  }
}

export function* postUsuarios(args) {
    try {
    const response = yield call(postUsuariosData, args.usuario);
    yield put(actions.successPostUsuarios(enrichUsuarioResponse(response, args.usuario)));
  } catch (error) {
    const reducerFailureAction = actions.errorPostUsuarios(error);
    yield handleSagaError(sagaNames.POST_USUARIOS, error, reducerFailureAction);
  }
}

export function* editUsuarios(args) {
  try {
    const response = yield call(putUsuariosData, args.usuario);
    yield put(actions.successEditUsuarios(enrichUsuarioResponse(response, args.usuario)));
  } catch (error) {
    const reducerFailureAction = actions.errorEditUsuarios(error);
    yield handleSagaError(sagaNames.EDIT_USUARIOS, error, reducerFailureAction);
  }
}

export function* deleteUsuarios(args) {
  try {
    const response = yield call(deleteUsuariosData, args.usuario);
    // const status = response && response.status;
    yield put(actions.successDeleteUsuarios(response));
  } catch (error) {
    const reducerFailureAction = actions.errorDeleteUsuarios(error);
    yield handleSagaError(sagaNames.DELETE_USUARIOS, error, reducerFailureAction);
  }
}

export function* deleteUsuariosBatch(args) {
  try {
    const response = yield call(deleteUsuariosBatchData, args.usuarioIds);
    const usuariosEliminados = Array.isArray(response?.data) ? response.data : [];

    for (const usuario of usuariosEliminados) {
      yield put(actions.updateUsuarios(usuario, methods.DELETE));
    }

    yield put(actions.successDeleteUsuariosBatch({
      status: response?.status,
      data: usuariosEliminados,
    }));
  } catch (error) {
    const reducerFailureAction = actions.errorDeleteUsuariosBatch(error);
    yield handleSagaError(sagaNames.DELETE_BATCH_USUARIOS, error, reducerFailureAction);
  }
}
